import { NavLink, Link, useLocation } from "react-router-dom";
import clsx from "clsx";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/programme", label: "Programme" },
  { to: "/book", label: "Book your day" },
  { to: "/invite", label: "Invite & win" },
  { to: "/stories", label: "Stories" },
  { to: "/howto", label: "Get there" },
  { to: "/contact", label: "Contact" },
];

export default function TopNav() {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-40 bg-cream/90 backdrop-blur border-b border-[#EFE7D2]"
    >
      <div className="container-x flex items-center justify-between py-3 md:py-4">
        <Link to="/" className="flex flex-col" data-testid="brand-link">
          <span className="font-serif text-xl md:text-2xl text-navy">
            Picnic in the <em className="italic-accent">Park</em>
          </span>
          <span className="text-[10px] tracking-[0.18em] uppercase text-grey">
            The Genesis · 19–20 Aug 2026
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => {
            const active = pathname === n.to || (n.to !== "/" && pathname.startsWith(n.to));
            return (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
                className={clsx(
                  "px-3 py-2 rounded-round text-sm transition-colors",
                  active ? "bg-cream text-navy font-bold" : "text-grey hover:text-navy"
                )}
              >
                {n.label}
              </NavLink>
            );
          })}
          <Link to="/book" className="btn-primary ml-2 text-sm py-2 px-5" data-testid="nav-book-cta">
            Book a day
          </Link>
        </nav>
      </div>
    </header>
  );
}
